import { Component } from '@angular/core';
import { TyloDeliveryPlanningListConfigService } from '../../services/tylo-delivery-planning-list-config.service';

@Component({
  selector: 'tylo-tylo-delivery-planning',
  template: `<lib-filter-list #orderRowList [configService]="configService"></lib-filter-list>`,
  styleUrls: ['./tylo-delivery-planning.component.css']
})
export class TyloDeliveryPlanningComponent {
  constructor(public configService: TyloDeliveryPlanningListConfigService) {}
}
